import { render, staticRenderFns } from "./TireListRecommenderLoader.vue?vue&type=template&id=4c614d4f"
import script from "./TireListRecommenderLoader.vue?vue&type=script&lang=ts"
export * from "./TireListRecommenderLoader.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports